import type { YaasPositionCardData } from "@solomon-apps/shared/src/types/yaas";
import type { BigDecimal } from "@solomon-labs/bigdecimal";

import { isRetailSelfHeldPosition } from "./isRetailSelfHeldPosition";

interface RetailPositionStateInput {
    positions: readonly YaasPositionCardData[];
    qualifyingBalance: BigDecimal | null;
    minBalance: BigDecimal;
    disabledByUser: boolean;
}

interface RetailPositionState {
    primaryPosition: YaasPositionCardData | null;
    isPositionDisabled: boolean;
    isBelowMinimum: boolean;
}

/** Address membership governs the wallet state even when an LP was updated more recently. */
export function retailPositionState(input: RetailPositionStateInput): RetailPositionState {
    const primaryPosition =
        input.positions.find((position) => isRetailSelfHeldPosition(position.pool)) ?? input.positions[0] ?? null;
    const isPositionDisabled = input.disabledByUser || primaryPosition?.position.status === "Disabled";
    const isBelowMinimum =
        !isPositionDisabled &&
        (!primaryPosition || primaryPosition.position.status === "Earning") &&
        (input.qualifyingBalance?.lt(input.minBalance) ?? false);
    return { primaryPosition, isPositionDisabled, isBelowMinimum };
}
